import React from 'react'

function TenderTextTwoside() {
  return (
    <embed src="\pdfs\DK-LIG-Z_Ausschreibungstext_2011-03.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextTwoside